import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import Avatar from "@/components/Avatar.vue";
let IncomingCallComponent = class IncomingCallComponent extends Vue {
    companyId;
    id;
    getOnlinePBXIncomingCallEvents;
    fetchCustomer;
    get onlinePBXIncomingCallEvent() {
        return this.getOnlinePBXIncomingCallEvents(this.companyId);
    }
    showPopover() {
        this.$nextTick(() => this.$bvToast.show(this.id));
    }
    hidePopover() {
        this.$nextTick(() => this.$bvToast.hide(this.id));
    }
    gotoCustomerPage() {
        if (!this.onlinePBXIncomingCallEvent.customer._id)
            return;
        this.fetchCustomer([this.onlinePBXIncomingCallEvent.customer._id, { skipRequestIfExists: true }]);
        this.$router.push({
            name: 'people.customer',
            params: {
                id: this.onlinePBXIncomingCallEvent.customer._id,
            }
        });
        this.hidePopover();
    }
    onOnlinePBXIncomingCallEvent(event, oldEvent) {
        if (event.direction !== 'inbound')
            return;
        if (event.event == 'call_start')
            this.showPopover();
        if (event.event == 'call_missed' || event.event == 'call_end' && oldEvent.uuid === event.uuid)
            this.hidePopover();
    }
};
__decorate([
    Prop({ type: String, required: true })
], IncomingCallComponent.prototype, "companyId", void 0);
__decorate([
    Prop({ type: String, default: 'incoming-call-component' })
], IncomingCallComponent.prototype, "id", void 0);
__decorate([
    Watch('onlinePBXIncomingCallEvent')
], IncomingCallComponent.prototype, "onOnlinePBXIncomingCallEvent", null);
IncomingCallComponent = __decorate([
    Component({
        computed: {
            ...mapGetters('onlinepbx-incoming-call', { getOnlinePBXIncomingCallEvents: 'get' }),
        },
        components: {
            Avatar
        },
        methods: {
            ...mapActions('customers', { fetchCustomer: 'get' }),
        }
    })
], IncomingCallComponent);
export default IncomingCallComponent;
